import { ProgressSpinner } from 'primereact/progressspinner';

export const Spinner = ({ className, style }) => <ProgressSpinner className={className} style={style} />;
